import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useThemeStore = defineStore("theme", () => {
  // State
  const isDark = ref(false);

  // Getters
  const mode = computed(() => (isDark.value ? "dark" : "light"));
  const themeClass = computed(() => (isDark.value ? "dark" : ""));

  // Actions
  function toggleTheme() {
    isDark.value = !isDark.value;
    updateDocumentClass();
    saveThemePreference();
  }

  function setTheme(dark: boolean) {
    isDark.value = dark;
    updateDocumentClass();
    saveThemePreference();
  }

  function initTheme() {
    // Check for saved theme preference or default to system preference
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      isDark.value = savedTheme === "dark";
    } else {
      // Use system preference
      isDark.value = window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
    updateDocumentClass();

    // Listen for system theme changes
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) => {
        if (!localStorage.getItem("theme")) {
          isDark.value = e.matches;
          updateDocumentClass();
        }
      });
  }

  function updateDocumentClass() {
    if (isDark.value) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }

  function saveThemePreference() {
    localStorage.setItem("theme", mode.value);
  }

  return {
    // State
    isDark,
    // Getters
    mode,
    themeClass,
    // Actions
    toggleTheme,
    setTheme,
    initTheme,
  };
});
